import type { CSSProperties, JSX } from "react";
import { KeelsonMark } from "./Logo.js";

function GoogleIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  );
}

function MicrosoftIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 21 21" width="18" height="18" aria-hidden="true" focusable="false">
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}

const btnWithIcon: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "0.5rem",
};

export function LoginGate(): JSX.Element {
  return (
    <div className="login-screen" data-testid="login-screen">
      <div className="login-lockup">
        <div className="login-mark">
          <KeelsonMark size={52} />
        </div>
        <div className="login-wordmark">Keelson</div>
        <div className="login-tagline">DORA Register of Information</div>
      </div>

      <div className="login-card">
        <h2>Sign in</h2>
        <p className="login-hint">
          Sign in with your organisation account to access your register.
        </p>
        <div className="login-providers">
          <a
            href="/api/auth/login?connection=google-oauth2"
            className="button"
            style={btnWithIcon}
            data-testid="login-google"
          >
            <GoogleIcon />
            Sign in with Google
          </a>
          <a
            href="/api/auth/login?connection=windowslive"
            className="button"
            style={btnWithIcon}
            data-testid="login-microsoft"
          >
            <MicrosoftIcon />
            Sign in with Microsoft
          </a>
        </div>
      </div>

      <p className="login-banner">
        <strong>Sample / unverified ruleset.</strong> Not for regulatory submission.
      </p>
    </div>
  );
}
